import isDemo from '@/lib/utils/is_demo';
import { httpPut, camelify } from '../rest';

export function updateAdvisorPhoto(httpPut, camelify, isDemo) {
  return {
    async execute({ photoUrl }) {
      let data;
      const params = {
        photo_url: photoUrl,
      };
      /* istanbul ignore if */
      if (isDemo()) {
        data = {
          photo_url:
            '../images/profile-photo.png',
        };
      } else {
        const response = await httpPut('/advisor_photos', params);
        data = response.data;
      }
      return camelify(data);
    },
  };
}

export default updateAdvisorPhoto(httpPut, camelify, isDemo);
